import IAnswer from "core/interfaces/IAnswer";
import XetuxProduct from "./types/XetuxProduct";

export interface XetuxProductsAnswer extends IAnswer {
    value: XetuxProduct[];
}

const XetuxProductsDefaultValue: XetuxProductsAnswer = { value: [], type: 'xetux-products'};

export default XetuxProductsDefaultValue;